import { Component } from '@angular/core';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from 'app/service/auth/user.service';

@Component({
    selector: 'app-estabelecimento',
    templateUrl: './estabelecimento.component.html',
    styleUrls: ['./estabelecimento.component.scss'],
    animations: fuseAnimations
})
export class EstabelecimentoComponent {

    constructor(
        private _fuseConfigService: FuseConfigService,
    ) {
    
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true }
            }
        };
    }
}
